if (!customElements.get('upsell-items')) {
  customElements.define(
    'upsell-items',
    class UpsellItems extends HTMLElement {
      constructor() {
        super();
        window.addEventListener('cart-drawer:open', this.cartCheck.bind(this));

        this.titleText = this.dataset.title;
        this.count = 0;
      }

      cartCheck() {
        const upsellJSON = document.querySelector('[type="application/json"][data-upsell-products]');
        if (upsellJSON) {
          this.upsellData = JSON.parse(upsellJSON.textContent);
          this.upsellData.find((upsell) => {
            if (upsell.variant.available) {
              this.fetchCartItems();
            }
          });
        } else {
          this.upsellData = [];
          const is_pdp = document.querySelector('[type="application/json"][data-product-id]') !== null;
          let productID;

          if (is_pdp) {
            this.fetchCartItems();

            productID = document.querySelector('[type="application/json"][data-product-id]').dataset.productId;
            this.fetchRecommendations(productID);
          } else {
            fetch('/cart.js')
              .then((response) => {
                return response.json();
              })
              .then(({ items }) => {
                this.cartItems = items;
                if (this.cartItems.length > 0) {
                  const randomProduct = this.cartItems[0];
                  productID = randomProduct.product_id;
                  this.fetchRecommendations(productID);
                }
              });
          }
        }
      }

      fetchCartItems() {
        fetch('/cart.js')
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            this.cartItems = data.items;
            if (this.cartItems.length > 0) {
              this.fetchUpsells();
            }
          });
      }

      fetchUpsells() {
        // Check if the cart has any items in it
        // If it does, then add the upsell items to the cart

        const upsellDiv = document.querySelector('.cart-upsells');
        upsellDiv.innerHTML = '';

        if (this.titleText) {
          upsellDiv.innerHTML = `<h4>${this.titleText}</h4>`;
        }
        this.upsellData.forEach((upsell) => {
          if (this.cartItems.some((item) => item.variant_id === upsell.variant.id) || !upsell.variant.available) {
            return;
          }
          this.count++;
          const upsellItem = document.createElement('div');
          upsellItem.classList.add('cart-upsell');
          upsellItem.innerHTML = `
          <div class="cart-upsell__left">
            <div class="cart-upsell__image">
              <img src="${upsell.image}" alt="${upsell.title}" />
            </div>
            <div class="cart-upsell__info">
              <h3 class="cart-upsell__title">${upsell.title}</h3>
              ${upsell.variant.title && upsell.variant.title != 'Default Title' ? `<span class="cart-upsell__variant-title">${upsell.variant.title}</span>` : ''}
              <p class="cart-upsell__price">${upsell.variant.price} ${
            upsell.variant.compare_at_price && upsell.variant.compare_at_price > upsell.variant.price ? `<span class="cart-upsell__compare-price">${upsell.variant.compare_at_price}</span>` : ''
          }</p>
            </div>
          </div>
          <div class="cart-upsell__right">
            <button class="btn btn--green upsell-add-to-cart" data-variant-id="${upsell.variant.id}">Add</button>
          </div>
        `;
          upsellDiv.appendChild(upsellItem);
        });

        this.activateATC();
        if (this.count > 0) {
          this.classList.add('show');
        }
      }

      fetchRecommendations(productID) {
        fetch(`${window.Shopify.routes.root}recommendations/products.json?product_id=${productID}&limit=3`)
          .then((response) => response.json())
          .then(({ products }) => {
            if (!products.length) {
              return;
            }
            products.forEach((product) => {
              //find first available variant
              const variant = product.variants.find((variant) => variant.available);
              this.upsellData.push({
                id: product.id,
                title: product.title,
                handle: product.handle,
                url: product.url,
                image: product.images[0],
                variant: { ...variant, price: Shopify.formatMoney(variant.price) },
              });
            });

            this.fetchUpsells();
          });
      }

      activateATC() {
        const addToCartButtons = document.querySelectorAll('.upsell-add-to-cart');
        addToCartButtons.forEach((button) => {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            let variantId = e.target.dataset.variantId;
            var quantity = 1;
            var params = {
              type: 'POST',
              url: '/cart/add.js',
              data: 'quantity=' + quantity + '&id=' + variantId,
              dataType: 'json',
              success: function (cart) {
                jQuery(document).trigger('cart.requestComplete', cart);
              },
              error: function (XMLHttpRequest, textStatus) {
                jQuery(document).trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
              },
              cache: false,
            };
            $.ajax(params);
          });
        });
      }
    }
  );
}
